export function rem(value: number | string, base = 16) {
  const pixels =
    typeof value === 'number' ? value : Number(value.replace(/px$/, ''));

  if (!isFinite(pixels)) {
    throw new Error(`Expected a pixel value, received "${value}".`);
  }

  return `${pixels / base}rem`;
}
